/**
 * Format a date string to locale date
 */
export function formatDate(dateStr: string): string {
  if (!dateStr) return ''
  return new Date(dateStr).toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
}

/**
 * Generate a short unique ID
 */
export function generateId(): string {
  return Math.random().toString(36).substring(2, 10)
}

/**
 * Truncate a string to a given length
 */
export function truncate(str: string, length: number): string {
  if (str.length <= length) return str
  return str.substring(0, length) + '…'
}

/**
 * Sorts select options so that:
 *   1. The placeholder (first element) stays first with value=""
 *   2. "Not in List" comes next, if present
 *   3. All remaining options are sorted alphabetically (case-insensitive)
 */
export function sortSelectOptions(options: string[]): string[] {
  if (options.length <= 1) return options
  const [placeholder, ...rest] = options
  const notInList = rest.filter(o => o === 'Not in List')
  const others = rest
    .filter(o => o !== 'Not in List')
    .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
  return [placeholder, ...notInList, ...others]
}

